import { BASE, INBOX, NOTIFICATIONS_PAGE } from '../../../../routes';
import { isFeatureEnabled } from '../../../services/Features';
import Link from '../../Link';
import NotificationsList from '../NotificationsList';
import NotificationsMarkAllAsReadButton from '../NotificationsMarkAllAsReadButton';
import styles from './style.m.less';

export default function NotificationsDropdown({ onCloseClick }) {
    const notificationsUrl = BASE + (isFeatureEnabled('FEATURE_inboxPage') ? INBOX : NOTIFICATIONS_PAGE);
    return (
        <div className={styles.container}>
            <div className={styles.inner}>
                <h1>
                    <a href={notificationsUrl} onClick={onCloseClick}>
                        Notifications
                    </a>
                    <div className={styles.header_buttons}>
                        <NotificationsMarkAllAsReadButton />
                    </div>
                </h1>
                <NotificationsList isDropdown={true} />
                <Link
                    href={notificationsUrl}
                    onClick={onCloseClick}
                    className={styles.see_all}
                    eventTracking={{ category: 'notifications', action: 'see all' }}
                >
                    See all Notifications
                </Link>
            </div>
        </div>
    );
}
